import BaseComponent from '../base-component/base-component'
import { delay, getTransitionDuration } from '../../utils/utils'
import type Quantity from '../quantity/quantity'

class CartItem extends BaseComponent {
  checkmarkSelector: string
  totalsSelector: string
  quantitySelector: string
  resizeObserver: ResizeObserver
  styles: CSSStyleDeclaration

  constructor() {
    super()

    this.checkmarkSelector = `[data-cart-item-checkmark]`
    this.totalsSelector = `[data-cart-item-totals]`
    this.quantitySelector = `[data-cart-item-quantity]`

    this.styles = getComputedStyle(this)

    this.resizeObserver = new ResizeObserver(this.handleResize)
    this.resizeObserver.observe(this)
  }

  connectedCallback(): void {
    this.setMaxHeight(this.scrollHeight)
  }

  disconnectedCallback(): void {
    this.resizeObserver.disconnect()
  }

  handleResize = (): void => {
    this.setMaxHeight(this.scrollHeight)
  }

  removeItem = (): void => {
    this.collapse().then(() => {
      this.remove()
    })
  }

  expand = (): Promise<void> => {
    this.setMaxHeight(this.scrollHeight)

    return delay(getTransitionDuration(this.styles))
  }

  collapse = (): Promise<void> => {
    this.setMaxHeight(0)

    return delay(getTransitionDuration(this.styles))
  }

  showCheckmark = (): void => {
    const checkmark = this.querySelector(this.checkmarkSelector)

    if (!checkmark) {
      return
    }

    checkmark.classList.remove('hidden')

    delay(2500).then(() => {
      checkmark.classList.add('hidden')
    })
  }

  setLoading = (isLoading: boolean): void => {
    const totals = this.querySelector<HTMLElement>(this.totalsSelector)

    if (!totals) {
      return
    }

    totals.toggleAttribute('is-loading', isLoading)
  }

  setMaxHeight(maxHeight: number): void {
    this.style.maxHeight = `${maxHeight}px`
  }

  setDisabled(isDisable: boolean): void {
    const quantity = this.querySelector<Quantity>(this.quantitySelector)

    if (!quantity) {
      return
    }

    quantity.setDisable(isDisable)
  }
}

export default CartItem
